import React from 'react';
import PropTypes from 'prop-types';
import { LockOutlined } from '@ant-design/icons';
import { Row, Col } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';

const CardCheckMessage = ({ plan }) => {
  const location = useLocation();
  const isCheckout = location.pathname === '/checkout';

  return plan?.isCreatorNetwork ? null : (
    <Row className="card-needed" align="middle">
      <Col span={20} className="no-padding">
        {plan?.isPaidPlan && (
          <FormattedMessage defaultMessage="Your card details are secured by Stripe" />
        )}

        {plan?.isFreePlan && (
          <>
            <p>
              <FormattedMessage defaultMessage="Have your card ready - we will do a credit card check to confirm your account." />
            </p>
            <p className="no-margin-bottom">
              <b>
                <FormattedMessage defaultMessage="You won't be charged" />
              </b>
            </p>
            {isCheckout && (
              <p>
                <FormattedMessage defaultMessage="Your card details are secured by Stripe" />
              </p>
            )}
          </>
        )}
      </Col>
      <Col span={4}>
        <Row align="middle" justify="center">
          <LockOutlined />
        </Row>
      </Col>
    </Row>
  );
};

CardCheckMessage.propTypes = {
  plan: PropTypes.object,
};

export default CardCheckMessage;
